module.exports = __webpack_public_path__ + "img/lygia.c22e1573.jpg";